import React, { useEffect, useState } from 'react';
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from '../../../../_metronic/_partials/controls';
import Table, {
	dateFormatter,
	buttonsStyle
} from '../../../components/tables/table';
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog';
import { getRoutinePlanTypes, deleteRoutinePlanType, changeStatusRoutinePlanType } from '../../../../api/routinePlanType';
import { Button, Tooltip } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { alertError, alertSuccess } from '../../../../utils/logger';
import { useHistory } from 'react-router-dom';
import ToggleOffIcon from '@material-ui/icons/ToggleOff';
import ToggleOnIcon from '@material-ui/icons/ToggleOn';
import { shallowEqual, useSelector } from 'react-redux';
import { getNonEmpty } from '../../../../utils/helpers';

function getData(routinePlanTypes) {
	let data = [];
	for (let i = 0; i < routinePlanTypes.length; ++i) {
		const elem = {};
		elem.name = getNonEmpty(routinePlanTypes[i].fullName);
		elem.createdAt = routinePlanTypes[i].createdAt;
		elem.id = routinePlanTypes[i]._id;
		elem.active = routinePlanTypes[i].active;
		data = data.concat(elem);
	}
	return data;
}

export default function RoutinePlanTypesPage() {
	const [data, setData] = useState([]);
	const [routinePlanTypeId, setRoutinePlanTypeId] = useState(null);
	const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
	const [refresh, setRefresh] = useState(false);
	const history = useHistory();
	const user = useSelector((store) => store.authentication?.user, shallowEqual)

	function buttonFormatter(cell) {
		const elem = data.find(item => item.id === cell)
		return (
			<>
				<Tooltip title='Edit'>
					<Button
						style={buttonsStyle}
						size='small'
						onClick={() => history.push('/edit-routine-plan-type/' + cell)}>
						<EditIcon />
					</Button>
				</Tooltip>
				{user?.role.includes('admin') && <>
					<Tooltip title={elem?.active ? "Disable" : "Enable"}>
						<Button
							style={buttonsStyle} size="small"
							onClick={() => {
								setRoutinePlanTypeId(elem)
								setOpenConfirmDialog(1)
							}}>
							{elem?.active ? <ToggleOffIcon/> : <ToggleOnIcon style={{ color: 'red' }} />}
						</Button>
					</Tooltip>
					<Tooltip title='Delete'>
						<Button
							style={buttonsStyle}
							size='small'
							onClick={() => {
								setRoutinePlanTypeId(cell);
								setOpenConfirmDialog(2);
							}}>
							<DeleteIcon />
						</Button>
					</Tooltip>
				</>}
			</>
		);
	}

	const columns = [
		{ dataField: 'name', text: 'Full name', sort: true },
		{
			dataField: 'createdAt',
			text: 'Created at',
			formatter: dateFormatter,
			sort: true,
		},
		{ dataField: 'id', text: '', formatter: buttonFormatter },
	];

	useEffect(() => {
		getRoutinePlanTypes()
			.then((res) => {
				if (res.status === 200) {
					setData(getData(res.data));
					setRefresh(false);
				}
			})
			.catch((error) => {
				alertError({ error: error, customMessage: 'Could not get routine plan types.' });
			});
	}, [refresh]);

	return (
		<>
			<Card>
				<CardHeader title='Routine plan types list'>
					<CardHeaderToolbar>
						<button
							type='button'
							className='btn btn-primary'
							onClick={() => history.push('/edit-routine-plan-type')}>
							Add new
						</button>
					</CardHeaderToolbar>
				</CardHeader>
				<CardBody>
					<Table data={data} columns={columns} />
					<ConfirmDialog
						title={`Are you sure you want to ${routinePlanTypeId?.active ? 'disable' : 'enable'} this routine plan type?`}
						open={openConfirmDialog === 1}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							changeStatusRoutinePlanType(routinePlanTypeId.id, !routinePlanTypeId?.active)
								.then((res) => {
									if (res.status === 200) {
										alertSuccess({ title: `${routinePlanTypeId?.active ? 'Disabled!' : 'Enabled!'}`, customMessage: `Routine plan type ${routinePlanTypeId?.active ? 'disabled' : 'enabled'} successfully` })
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({ error: error, customMessage: `Could not ${routinePlanTypeId?.active ? 'disable' : 'enable'} routine plan type.` })
								});
						}}
					/>
					<ConfirmDialog
						title={'Are you sure you want to remove this routine plan type?'}
						open={openConfirmDialog === 2}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							deleteRoutinePlanType(routinePlanTypeId)
								.then((res) => {
									if (res.status === 204 || res.status === 200) {
										alertSuccess({
											title: 'Deleted!',
											customMessage: 'Routine plan type removed successfully.',
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage: 'Could not remove routine plan type.',
									});
								});
						}}
					/>
				</CardBody>
			</Card>
		</>
	);
}
